import { useQuery } from "@tanstack/react-query";
import { getCategories } from "@/services/api.js";
import { reactQueryCacheAndRefetchOptions } from "@";

// Hook for fetching categories list for dropdowns/selects
export const useCategoriesQuery = () => {
  return useQuery({
    queryKey: ["categories-options"],
    queryFn: async () => {
      const { data } = await getCategories();

      if (!data) return [];

      // Map to options format for Select component
      return (
        data?.map((category) => ({
          value: category.id,
          label: category.name,
        })) || []
      );
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};